import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import cn from 'classnames';

import styles from './tabGroup.module.scss';

const TabGroup = ({ items }) => {
  return (
    <div className={styles.tabGroup}>
      {items.map(item => {
        const tabClass = cn(styles.tab, {
          [styles.tabActive]: item.isActive,
        });

        if (item.to) {
          return (
            <Link key={item.key} to={item.to} className={tabClass}>
              {item.label}
            </Link>
          );
        }

        return (
          <button
            key={item.key}
            type="button"
            className={tabClass}
            onClick={item.onClick}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};

TabGroup.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      isActive: PropTypes.bool.isRequired,

      // optional:
      to: PropTypes.string,
      onClick: PropTypes.func,
    })
  ).isRequired,
};

export default TabGroup;
